import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowBack = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M435-188 171-452q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l264-264q11-11 27.5-11.5T491-772q12 11 12.5 27.5T492-716L296-520h447q17 0 28.5 11.5T783-480t-11.5 28.5T743-440H296l196 196q11 11 11.5 28T492-188q-11 12-28 12t-29-12" })));
const ForwardRef = forwardRef(SvgArrowBack);
const Memo = memo(ForwardRef);
export default Memo;
